import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {ENTITY_TYPES} from "../../../core/app/consts";
import {CalculatorLinkParams} from "./calculator-link-params";

export class CalculatorLinkModel extends BaseLinkModel  {
  constructor(entityType: ENTITY_TYPES, entityId: Number) {
    super(ROUTE_NAMES.calculator, new CalculatorLinkParams(entityType, entityId));
  }
}